//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Chart from "chart.js";
import { mapActions } from "vuex";
import DeviceReport from "./DeviceReport.vue";
import sharedMethods from "../../sharedMethods";
import StandbyBadge from "../Devices/StandbyBadge.vue";

export default {
  name: "dashboard-chart",
  components: {
    DeviceReport,
    StandbyBadge,
  },

  data() {
    return {
      chart: null,
      chartElement: null,
      online: null,
      offline: null,
      total: null,
      offlineDevices: null,
      onlineDevices: null,
      cX: null,
      cY: null,
      playlistsLoaded: false,
    };
  },
  computed: {
    sharedMethods() {
      return sharedMethods;
    },
  },
  mounted() {
    this.fetchDeviceStates().then((response) => {
      this.online = response.data.online;
      this.offline = response.data.offline;
      this.total = response.data.deivesTotal;
      this.offlineDevices = response.data.offlineDevices;
      this.onlineDevices = response.data.onlineDevices;

      Chart.pluginService.register({
        beforeDraw: function(chart) {
          if (chart.config.options.elements.center) {
            // Get ctx from string
            var ctx = chart.chart.ctx;

            // Get options from the center object in options
            var centerConfig = chart.config.options.elements.center;
            var fontStyle = centerConfig.fontStyle || "Lato";
            var txt = centerConfig.text;
            var color = centerConfig.color || "#000";
            var maxFontSize = centerConfig.maxFontSize || 55;
            var sidePadding = centerConfig.sidePadding || 15;
            var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
            // Start with a base font of 30px
            ctx.font = "10px " + fontStyle;

            // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
            var stringWidth = ctx.measureText(txt).width;
            var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

            // Find out how much the font can grow in width.
            var widthRatio = elementWidth / stringWidth;
            var newFontSize = Math.floor(30 * widthRatio);
            var elementHeight = chart.innerRadius * 2;

            // Pick a new font size so it will not be larger than the height of label.
            var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
            var minFontSize = centerConfig.minFontSize;
            var lineHeight = centerConfig.lineHeight || 25;
            var wrapText = false;

            if (minFontSize === undefined) {
              minFontSize = 5;
            }

            if (minFontSize && fontSizeToUse < minFontSize) {
              fontSizeToUse = minFontSize;
              wrapText = true;
            }

            // Set font settings to draw it correctly.
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            this.cX = centerX;
            this.cY = centerY;

            ctx.font = fontSizeToUse + "px " + fontStyle;

            ctx.fillStyle = color;

            if (!wrapText) {
              ctx.fillText(txt, centerX, centerY);
              return;
            }

            var words = txt.split(" ");
            var line = "";
            var lines = [];

            // Break words up into multiple lines if necessary
            for (var n = 0; n < words.length; n++) {
              var testLine = line + words[n] + " ";
              var metrics = ctx.measureText(testLine);
              var testWidth = metrics.width;
              if (testWidth > elementWidth && n > 0) {
                lines.push(line);
                line = words[n] + " ";
              } else {
                line = testLine;
              }
            }

            // Move the center up depending on line height and number of lines
            centerY -= (lines.length / 2) * lineHeight;

            for (var n = 0; n < lines.length; n++) {
              ctx.fillText(lines[n], centerX, centerY);
              centerY += lineHeight;
            }
            //Draw text in center
            ctx.fillText(line, centerX, centerY);
          }
        },
      });

      this.chartElement = document.getElementById("dashChart");
      var ctx = document.getElementById("dashChart").getContext("2d");
      var gradient = ctx.createRadialGradient(this.cX, this.cY, 0, this.cX, this.cY, 400);
      gradient.addColorStop(0, "#be506e");
      gradient.addColorStop(0.25, "#be506e");
      gradient.addColorStop(0.75, "#eea65f");
      gradient.addColorStop(1, "#eea65f");
      var gradient2 = ctx.createRadialGradient(this.cX, this.cY, 0, this.cX, this.cY, 370);
      gradient2.addColorStop(0, "#8e9899");
      gradient2.addColorStop(0.25, "#232425");
      gradient2.addColorStop(0.75, "#8e9899");
      gradient2.addColorStop(1, "#232425");

      this.chart = new Chart(this.chartElement, {
        type: "doughnut",

        data: {
          labels: ["online", "offline"],
          datasets: [
            {
              aspectRatio: 1,
              data: [this.online, this.offline],
              borderWidth: 0,
              fill: false,
              backgroundColor: [gradient, "#3b4045"],
            },
          ],
        },

        options: {
          responsive: true,
          cutoutPercentage: 69,
          segmentShowStroke: false,
          height: "60%",
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          elements: {
            center: {
              text: this.online + "/" + this.total,
              color: "#3b4045", // Default is #000000
              fontStyle: "Lato", // Default is Arial
              sidePadding: 20, // Default is 20 (as a percentage)
              fontSize: 10,
              minFontSize: 5, // Default is 20 (in px), set to false and text will not wrap.
              lineHeight: 25, // Default is 25 (in px), used for when text wraps
            },
          },

          plugins: {},
        },
      });
    });
  },
  methods: {
    ...mapActions(["fetchDeviceStates"]),

    showDeviceReport(device) {
      this.$q.dialog({
        component: DeviceReport,
        root: this,
        device: device,
      });
    },
  },
};
